<template>
  <v-container fluid style="padding: 0px">
    <v-layout wrap>
      <v-flex xs12>
        <Subheader v-model="search" title="Unit Groups" search="Unit Group">
          <v-btn color="success" @click="clickAddUnitGroup()">
            <v-icon class="mr-1">add</v-icon>{{ $t('Button.AddUnitGroup') }}
          </v-btn>
        </Subheader>
        <v-card>
          <v-card-text>
            <v-data-table :headers="headers" :items="allUnitGroups" :pagination.sync="pagination" :search="search">
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.Name }}</td>
                <td class="text-xs-right">
                  <v-btn dark color="warning" :to="{ name: 'UnitGroupDetail', params: {unitGroupName: props.item.Name} }">
                    <v-icon class="mr-1">edit</v-icon>{{ $t('Button.Edit') }}
                  </v-btn>
                  <v-btn dark color="delete" @click="clickDeleteGroup(props.item)">
                    <v-icon class="mr-1">delete_forever</v-icon>{{ $t('Button.Remove') }}
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>

    <app-modal v-model="addDialog" persistent max-width="800">
      <template v-slot:title>{{ $t('Button.AddUnitGroup') }}</template>
      <template v-slot:text>
        <v-layout wrap>
          <v-flex xs12 pl-3 pr-3>
            <v-text-field label="Unit Group Name" v-model="unitGroupData.unitGroupName" required>
            </v-text-field>
          </v-flex>
          <v-flex xs12 pl-3 pr-3>
            <v-autocomplete label="Applicable Units" v-bind:items="allUnitName" v-model="unitGroupData.incloudingUnits" multiple hint="Select units to include" persistent-hint item-text="Name" item-value="Id" return-object>
            </v-autocomplete>
          </v-flex>
        </v-layout>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="clickSaveGroup()">
          <v-icon>done</v-icon>{{ $t('Button.Save') }}
        </v-btn>
        <v-btn color="secondary" @click="closeDialog()" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <app-modal v-model="dialog" persistent max-width="800">
      <template v-slot:title>{{dialogMessage}}</template>
      <template v-slot:text>
        {{ $t('UnitGroupDetail.deleteMsg') }}
        <v-checkbox v-model="deleteGroup.IsDeleteUnit" label="Delete Group And Units"></v-checkbox>
      </template>
      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn dark color="delete" @click="agreeDeleteGroup()">
          <v-icon>delete_forever</v-icon>{{ $t('Button.Remove') }}
        </v-btn>
        <v-btn color="secondary" @click="dialog = false" outline>{{ $t('Button.Cancel') }}</v-btn>
      </template>
    </app-modal>

    <v-card color="grey lighten-4">
      <v-snackbar style="text-align:left" auto-height :color="snackbar.snackbarColor" :timeout="null" top v-model="snackbar.isSnackbarShow">
        {{ snackbar.snackbarMessage }}
        <v-btn dark icon @click="hideSnackbar()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-snackbar>
    </v-card>
  </v-container>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'
  import { errorMessage } from '@/helpers/exceptionHandling'
  import MessageUtil from '../mixins/MessageUtil'
  import Subheader from '@/components/generic/Subheader'
  import AppModal from '@/components/generic/AppModal'

  const unit = createNamespacedHelpers('unit')

  export default {
    components: {
      Subheader,
      'app-modal': AppModal,
    },
    mixins: [MessageUtil],
    data() {
      return {
        search: '',
        headers: [{
          text: 'Unit Group',
          value: 'Name',
          align: 'left',
        },
        {
          text: 'Action',
          value: null,
          align: 'right',
        },
        ],
        pagination: {
          sortBy: 'longName',
          rowsPerPage: 10,
        },
        addDialog: false,
        editUnitGroupable: 1, //state 0:clear; 1:add; 2:edit
        groupId: -1,
        currentGroup: {},
        unitGroupData: {
          unitGroupId: '',
          unitGroupName: '',
          incloudingUnits: [],
        },
        deleteGroup: {
          deleteGroupId: '',
          IsDeleteUnit: false,
        },
        deleteGroupName: '',
        dialog: false,
        dialogMessage: '',
        dialogState: '',
      }
    },
    computed: {
      ...unit.mapGetters(['allUnitGroups', 'unitDetail', 'allUnits']),
      allUnitName() {
        let arr = []
        this.allUnits.forEach(e => {
          arr.push({
            Name: e.Groups.length == 0 ? e.Name : e.Name + ' (' + this.getThisUnitGroupName(e.Groups).toString() + ')',
            Id: e.Id,
          })
        })
        return arr
      },
    },
    watch: {},
    methods: {
      ...unit.mapActions([
        'getUnitList',
        'getUnitGroup',
        'getUnitDetail',
        'postAddUnitGroup',
        'postEditUnitGroup',
        'postDeleteUnitGroup',
      ]),
      getThisUnitGroupName(GroupList) {
        let arr = []
        GroupList.forEach(e => {
          arr.push(e.Name)
        })
        return arr
      },
      clickAddUnitGroup() {
        this.emptyUnitGroupData()
        this.editUnitGroupable = 1
        this.groupId = -1
        this.addDialog = true
      },
      agreeSaveGroup() {
        let options = {
          data: {
            Id: null,
            Name: this.unitGroupData.unitGroupName,
            Units: this.unitGroupData.incloudingUnits,
          },
          successCb: () => {
            this.showSnackbar(`Unit group: ${ this.unitGroupData.unitGroupName } is added successfully`,
                'success')
            this.dialog = false
            this.addDialog = false
          },
          failedCb: err => {
            this.showSnackbar(`Add unit group request failed. ${errorMessage(err)}`, 'error')
          },
        }
        this.postAddUnitGroup(options)
      },
      agreeDeleteGroup() {
        this.dialog = false
        let options = {
          data: this.deleteGroup,
          successCb: () => {
            this.showSnackbar(`Unit Group: ${ this.deleteGroupName } removed successfully`, 'success')
          },
          failedCb: err => {
            this.showSnackbar(`Delete unit group request failed. ${errorMessage(err)}`, 'error')
          },
        }
        this.postDeleteUnitGroup(options)
      },
      emptyUnitGroupData() {
        this.unitGroupData = {
          unitGroupId: '',
          unitGroupName: '',
          incloudingUnits: [],
        }
      },
      enableDialog(state, message) {
        this.dialog = true
        this.dialogState = state
        this.dialogMessage = message
      },
      clickDeleteGroup(data) {
        this.enableDialog(
          'deleteGroup',
          `Are you sure to delete Unit Group: ${ data.Name }?`
        )
        this.deleteGroup.deleteGroupId = data.Id
        this.deleteGroupName = data.Name
      },
      clickSaveGroup() {
        let groupName = []
        this.allUnitGroups.map(e => groupName.push(e.Name))
        if (this.unitGroupData.unitGroupName) {
          let match = this.allUnitGroups.find(e => e.Name.toLowerCase() == this.unitGroupData.unitGroupName.toLowerCase())
          if (match) {
            this.showSnackbar(`Add unit group request failed. Unit Group ${this.unitGroupData.unitGroupName} already exists in the system, please enter correct Unit Group Name.`,
              'error')
          } else {
            this.agreeSaveGroup()
          }
        } else {
          this.showSnackbar('Add unit group request failed. Unit Group Name cannot be null, please enter Unit Group Name.', 'error')
        }
      },
      closeDialog() {
        this.addDialog = false
      },
    },
  }
</script>

<style>
</style>